import { request } from '@/api/client';
import { ClientAuth } from '@/classes/ClientAuth';
import { API_URL, API_VERSION } from '@/constants';

export async function syncSubscriptions(): Promise<void> {
  await request({
    url: `${API_URL}/api/${API_VERSION}/membership/subscriptions/sync`,
    init: { method: 'POST', headers: ClientAuth.headers, credentials: 'include' },
  });
}

export async function getSubscriptionUUID(): Promise<string> {
  const response = await fetch(`${API_URL}/api/${API_VERSION}/membership/subscriptions/uuid`, {
    method: 'GET',
    headers: ClientAuth.headers,
    credentials: 'include',
  });
  const data = await response.text();

  return data;
}

export async function getSubscriptionURLIsRedirected(): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/${API_VERSION}/membership/subscriptions/redirected`, {
    method: 'GET',
    headers: ClientAuth.headers,
    credentials: 'include',
  });
  const data = await response.json();

  return data;
}

export async function isCouponAvailable(code: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/${API_VERSION}/membership/coupons/${code}/available`, {
    method: 'GET',
    headers: ClientAuth.headers,
    credentials: 'include',
  });
  const data = await response.json();

  return data;
}
